import { render, staticRenderFns } from "./list-truewallet.vue?vue&type=template&id=69953e68&"
import script from "./list-truewallet.vue?vue&type=script&lang=js&"
export * from "./list-truewallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports